export default __webpack_public_path__ + "static/media/logo_dark.d48f46fe.svg";